import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the RepresentantePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-representante',
  templateUrl: 'representante.html',
})
export class RepresentantePage {
  isBrowser = false

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.isBrowser = this.navParams.get("isBrowser")

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RepresentantePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/representante/representante.ts